"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = showIf;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ShowIfContext = _interopRequireDefault(require("../ShowIfProvider/ShowIfContext"));

var _resolveShowIf = _interopRequireDefault(require("../utils/resolveShowIf"));

/**
 * Return enhaced component based on `Component`.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function showIf( // IntrinsicAttributes
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Component) {
  var ShowIfWrapper = /*#__PURE__*/_react.default.forwardRef(function ShowIfWrapper(_ref, ref) {
    var _ref$showIf = _ref.showIf,
        showIfProp = _ref$showIf === void 0 ? true : _ref$showIf,
        restTmp = (0, _objectWithoutProperties2.default)(_ref, ["showIf"]);

    var ctx = _react.default.useContext(_ShowIfContext.default);

    var resolveCtx = function resolveCtx(c) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var updateSettings = c.updateSettings,
          rest = (0, _objectWithoutProperties2.default)(c, ["updateSettings"]);
      return rest;
    };

    var rest = (0, _extends2.default)({
      ref: ref
    }, restTmp);
    return ctx === null || (0, _resolveShowIf.default)(resolveCtx(ctx), showIfProp) ?
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    _react.default.createElement(Component, rest) : null;
  });

  process.env.NODE_ENV !== "production" ? ShowIfWrapper.propTypes = {
    /**
     * Podminene zobrazeni vysledku.
     *
     * Pokud je hodnota `false`, nebo vysledek volani funkce je `false`,
     * komponenta se nebude zobrazovat.
     *
     * Funkce ma format `(showIfContext) => bool`.
     */
    showIf: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.func, _propTypes.default.oneOf(['isAdmin', 'anonymouse'])]) // eslint-disable-next-line @typescript-eslint/no-explicit-any

  } : void 0;
  ShowIfWrapper.defaultProps = {
    showIf: true // eslint-disable-next-line @typescript-eslint/no-explicit-any

  };
  ShowIfWrapper.displayName = "ShowIf".concat(Component.displayName || Component.name || 'Component');
  return ShowIfWrapper;
}